import React, { useEffect } from "react";
import { Container, makeStyles, Typography, Card, CardContent } from "@material-ui/core";
//function
import { headRewrite } from "../function/headRewrite";

const useStyles = makeStyles((theme) => ({
    enforcement: {
        fontWeight: "bold",
        marginTop: theme.spacing(2),
    },
    root: {
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(10, 1, 15, 1),
        },
        [theme.breakpoints.up("sm")]: {
            margin: theme.spacing(10, 2, 15, 2),
        },
        [theme.breakpoints.up("md")]: {
            margin: theme.spacing(10, 3, 15, 3),
        },
        color: "black",
        backgroundColor: "white",
    },
    regulation: {
        textAlign: "center",
        fontWeight: "bold",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    subtitle: {
        textAlign: "right",
    },
    title: {
        fontWeight: "bold",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    body: {
        whiteSpace: "pre-line",
        lineHeight: 1.9,
    },
}));

const terms = [
    {
        title: "第１条（定義）",
        body: `本規約において使用する用語の定義は、次に掲げるとおりとします。

（１）「本サービス」とは、Enclopediaが運営するウェブサイト、アプリケーションその他の媒体を通じて提供する、ファッションアイテム等のレンタル、購入、買取、情報提供その他これらに付随するサービスをいいます。

（２）「本サイト」とは、本サービスのコンテンツが掲載されたウェブサイトをいいます。

（３）「本コンテンツ」とは、本サービス上で提供される文字、画像、動画、音声、ソフトウェア、プログラム、コード、デザイン、投稿情報その他一切の情報をいいます。

（４）「利用者」とは、本サービスを利用する全ての方をいいます。

（５）「会員」とは、本サービス上で所定の会員登録を完了した利用者をいいます。

（６）「登録希望者」とは、本サービスの会員登録を希望する方をいいます。

（７）「登録情報」とは、会員登録時または本サービス利用時に利用者がEnclopediaに提供した氏名、住所、電話番号、生年月日、メールアドレス、決済情報その他一切の情報をいいます。

（８）「レンタルアイテム」とは、本サービスを通じてEnclopediaが会員に貸し出す衣類、服飾雑貨、付属品その他の商品をいいます。

（９）「商品ページ」とは、本サービス上に掲載される各レンタルアイテムの商品詳細ページをいいます。

（１０）「レンタル料」とは、商品ページまたは注文画面に記載されたレンタルアイテムの利用料金をいいます。

（１１）「返却手数料」とは、返却に関して商品ページまたは注文画面に表示される手数料をいいます。

（１２）「商品購入金額」とは、商品ページに記載された、当該レンタルアイテムを購入する場合の金額をいいます。

（１３）「返却期限日」とは、商品ページ、注文画面、マイページ、メール、SMSその他Enclopediaが指定する方法により会員に通知される、レンタルアイテムの返却期限日をいいます。

（１４）「返却完了」とは、会員が本サービス上で指定された返却手続きを行い、かつEnclopediaが指定する方法により運送会社への引渡しが確認された状態をいいます。

（１５）「知的財産」とは、発明、考案、意匠、著作物、商標、商号、営業秘密その他事業活動に用いられる技術上または営業上の情報をいいます。

（１６）「知的財産権」とは、特許権、実用新案権、意匠権、著作権、商標権その他知的財産に関して法令により認められる権利または法律上保護される利益をいいます。`,
    },
    {
        title: "第２条（本規約への同意）",
        body: `（１）利用者は、本規約に同意したうえで、本サービスを利用するものとします。

（２）利用者が本サービス上で会員登録を行い、本規約への同意手続きを完了した時点で、利用者とEnclopediaとの間に、本規約に基づく利用契約が成立するものとします。

（３）利用者が未成年者である場合、親権者その他の法定代理人の同意を得たうえで本サービスを利用するものとします。

（４）未成年者の利用者が、法定代理人の同意がないにもかかわらず同意があると偽り、または年齢について成年であると偽って本サービスを利用した場合、その他行為能力者であることを信じさせるために詐術を用いた場合、本サービスに関する一切の法律行為を取り消すことはできません。

（５）本規約への同意時に未成年であった利用者が、成年に達した後に本サービスを利用した場合、当該利用者は本サービスに関する一切の法律行為を追認したものとみなします。`,
    },
    {
        title: "第３条（規約の変更）",
        body: `（１）Enclopediaは、法令上認められる範囲において、本規約の内容を変更することができるものとします。

（２）Enclopediaは、本規約を変更する場合、変更後の内容および効力発生日を、本サイトへの掲載、メール、SMS、本サービス上の通知その他Enclopediaが適切と判断する方法により利用者に通知します。

（３）変更後の本規約は、前項に定める効力発生日から効力を生じるものとします。

（４）利用者が本規約変更後に本サービスを利用した場合、変更後の本規約に同意したものとみなします。`,
    },
    {
        title: "第４条（会員登録、利用審査および登録条件）",
        body: `（１）会員とは、本規約に同意したうえでEnclopedia所定の方法により会員登録を申し込み、Enclopediaがこれを承認した方をいいます。

（２）登録希望者は、会員登録にあたり、正確かつ最新の情報をEnclopediaに提供しなければなりません。

（３）Enclopediaは、登録希望者による会員登録の申込みを承認するか否かを、Enclopediaの裁量により判断できるものとします。

（４）Enclopediaは、会員に対し、メール、SMS、本サービス上の通知その他Enclopediaが適切と判断する方法により、連絡事項、重要事項、広告、キャンペーンその他の情報を提供できるものとします。

（５）次の各号のいずれかに該当する場合、会員登録を行うことはできません。

一 有効なメールアドレス、電話番号、スマートフォンその他本サービスの利用に必要な通信環境を有していない場合

二 既に会員登録を行っている場合

三 Enclopediaが指定する決済方法を利用できない場合

四 登録情報に虚偽、不備、誤り、第三者情報の使用がある場合

五 過去に本規約またはEnclopediaが定めるその他の規約に違反したことがある場合

六 過去に返却遅延、未返却、紛失、汚損、破損、すり替え、決済不能その他本サービスの利用に関する問題があった場合

七 不正な手段により登録を行っている、またはそのおそれがあるとEnclopediaが判断した場合

八 反社会的勢力等に該当し、または関与しているとEnclopediaが判断した場合

九 その他Enclopediaが会員登録を不適切と判断した場合

（６）Enclopediaは、登録希望者または会員について、登録情報、本人確認情報、決済手段、過去の利用履歴、返却状況、連絡状況、不正利用の疑いその他Enclopediaが必要と判断する情報をもとに、利用審査を行うことができるものとします。

（７）Enclopediaは、登録希望者または会員が次の各号のいずれかに該当すると判断した場合、会員登録の拒否、注文の取消し、レンタルアイテムの発送停止、会員資格の停止または取消し、以後の利用拒否その他必要な措置を取ることができるものとします。

一 過去に返却遅延、未返却、紛失、汚損、破損、すり替え、決済不能その他本規約違反があった場合

二 登録情報に虚偽、不備、誤り、第三者情報の使用がある場合

三 同一人物が複数のアカウントを作成または利用しているとEnclopediaが判断した場合

四 本人確認または決済確認が完了しない場合

五 Enclopediaからの連絡に対して相当期間応答がない場合

六 その他Enclopediaが本サービスの利用を不適切と判断した場合`,
    },
    {
        title: "第５条（アカウントおよび登録情報の管理）",
        body: `（１）会員は、メールアドレス、ID、パスワードその他本サービスの利用に必要な情報を、自己の責任において厳重に管理するものとします。

（２）会員は、自己のアカウント、ID、パスワードその他登録情報を第三者に利用させ、貸与、譲渡、名義変更、売買、担保提供その他の処分をしてはならないものとします。

（３）登録情報を用いて本サービスが利用された場合、Enclopediaは、当該登録情報に対応する会員本人による利用とみなすことができるものとします。

（４）会員は、登録情報の管理不備、使用上の過誤、第三者による使用その他会員の責めに帰すべき事由によりEnclopediaまたは第三者に損害が生じた場合、当該損害を賠償するものとします。

（５）登録情報が不正確または虚偽であったことにより会員に不利益または損害が生じた場合であっても、Enclopediaは一切の責任を負いません。

（６）登録情報が盗用され、または第三者に利用されていることが判明した場合、会員は直ちにその旨をEnclopediaに通知し、Enclopediaからの指示に従うものとします。

（７）会員は、氏名、住所、電話番号、生年月日、メールアドレス、決済情報その他登録情報に変更が生じた場合、遅滞なくEnclopedia所定の方法により変更手続きを行うものとします。

（８）会員が登録情報の変更を怠ったことにより、商品が配送できない、通知が到達しない、本人確認ができない、決済ができないその他の不利益または損害が発生した場合、当該不利益または損害は会員が負担するものとし、Enclopediaは一切の責任を負いません。

（９）会員が登録情報の変更を怠ったことによりEnclopediaに損害が発生した場合、会員は当該損害を賠償するものとします。

（１０）会員は、同一人物が複数のメールアドレス、電話番号、氏名表記、住所表記その他の情報を用いて、複数のアカウントを作成または利用してはならないものとします。

（１１）Enclopediaは、氏名、住所、電話番号、メールアドレス、配送先、決済手段、利用端末、アクセス情報、注文履歴その他の情報から、複数アカウントの利用、不正利用、利用停止回避その他本規約違反の疑いがあると判断した場合、当該会員に事前に通知することなく、注文の取消し、発送停止、会員資格の停止または取消し、以後の利用拒否その他必要な措置を取ることができるものとします。`,
    },
    {
        title: "第６条（個人情報の取扱い）",
        body: `Enclopediaは、利用者の個人情報および利用者情報を、別途定める「Enclopediaファッションレンタルサービスプライバシーポリシー」に従い、適正に取り扱います。`,
    },
    {
        title: "第７条（禁止行為）",
        body: `利用者は、本サービスの利用にあたり、次の各号に掲げる行為を行ってはならないものとします。Enclopediaは、利用者が禁止事項に違反したと判断した場合、会員資格の停止または取消し、注文の取消し、レンタルアイテムの発送停止、以後の利用拒否、損害賠償請求その他Enclopediaが必要と判断する措置を取ることができます。

（１）Enclopediaまたは第三者の知的財産権を侵害する行為

（２）Enclopediaまたは第三者の名誉、信用、プライバシーその他の権利または利益を侵害する行為

（３）Enclopediaまたは第三者の財産を侵害する行為、またはそのおそれのある行為

（４）Enclopediaまたは第三者に経済的損害を与える行為

（５）Enclopediaまたは第三者に対する脅迫的、暴力的、差別的、誹謗中傷的な行為

（６）コンピューターウイルス、有害なプログラムを使用、送信、掲載、またはこれらを誘発する行為

（７）本サービスのサーバー、ネットワーク、システムその他インフラ設備に過度な負担をかける行為

（８）本サービスのサーバー、システム、セキュリティを攻撃し、または不正にアクセスする行為

（９）Enclopediaが提供するインターフェース以外の方法で本サービスにアクセスし、またはアクセスを試みる行為

（１０）一人の利用者が複数のアカウントを作成または利用する行為

（１１）第三者になりすます行為

（１２）虚偽または不正確な情報を登録する行為

（１３）本人以外の氏名、住所、電話番号、メールアドレス、決済手段その他の情報を使用する行為

（１４）レンタルアイテムを第三者に貸し出し、譲渡し、売却し、質入れし、担保提供し、処分し、または第三者に占有させる行為

（１５）レンタルアイテムを故意または過失により損傷、汚損、変色、変質、改造、分解する行為

（１６）レンタルアイテムを別の商品、模造品、偽物、類似品その他Enclopediaが発送した商品と異なる物にすり替える行為

（１７）レンタルアイテムを違法行為または公序良俗に反する目的で使用する行為

（１８）返却期限を過ぎてもレンタルアイテムを返却せず、またはEnclopediaからの連絡に応答しない行為

（１９）登録済み決済手段による請求を不当に拒否し、または決済不能の状態を放置する行為

（２０）本人確認、配送、受取、返却、決済その他本サービスの運営に必要な手続きを妨げる行為

（２１）利用停止、会員資格停止、注文拒否その他Enclopediaによる措置を回避する目的で、別のアカウント、別の氏名、別の電話番号、別のメールアドレス、別の住所、第三者名義その他の情報を用いる行為

（２２）本サービスを利用して法令に違反する行為、または犯罪行為に関連する行為

（２３）反社会的勢力等への利益供与その他これに関与する行為

（２４）その他Enclopediaが不適切と判断する行為`,
    },
    {
        title: "第８条（商品のレンタル、返却および返却期限超過時の取扱い）",
        body: `（１）会員は、本規約、本サービス上の表示、商品ページ、注文画面その他Enclopediaが別途定める条件に従い、レンタルアイテムを借り受けるものとします。会員は、レンタルアイテムの借受けにあたり、レンタル期間、返却期限、レンタル料、返却方法、返却手続き、購入可能金額その他の条件を確認し、これに同意したものとみなします。

（２）レンタルアイテムの通常レンタル期間は、商品ページまたは注文画面に別段の定めがある場合を除き、商品受取日、利用期間10日間および返却期限日を含む合計12日間とします。会員は、返却期限日までに、本サービス上で指定された返却手続きおよび運送会社への引渡しを完了しなければなりません。

（３）会員が返却期限日までにレンタルアイテムの返却手続きまたは運送会社への引渡しを完了しない場合、Enclopediaは、当該レンタルアイテムのレンタル期間が自動的に延長されたものとして、商品ページに記載された当該レンタルアイテムのレンタル料と同額を、自動延長レンタル料として会員に請求できるものとします。なお、自動延長レンタル料には、返却手数料その他の手数料は含まれません。

（４）会員は、前項に定める自動延長レンタル料、未返却時の商品購入金額相当額、修繕費用、特殊クリーニング費用、回収費用、送料その他本規約に基づき発生する一切の金銭債務について、会員が本サービスに登録したクレジットカードその他の決済手段によりEnclopediaが請求することにあらかじめ同意するものとします。

（５）第３項に基づき自動延長レンタル料が発生した場合、Enclopediaは、当初の返却期限日の翌日から起算して、商品受取日を含まない11日間相当の自動延長期間を設定することができるものとします。会員は、Enclopediaが指定する再返却期限日までに、レンタルアイテムの返却手続きおよび運送会社への引渡しを完了しなければなりません。

（６）会員が再返却期限日までにレンタルアイテムを返却しない場合、またはEnclopediaからのメール、SMS、電話その他の連絡に対して応答せず返却の意思が確認できない場合、Enclopediaは、当該レンタルアイテムについて、返却不能、紛失、または実質的な購入とみなし、商品ページに記載された商品購入金額相当額を会員に請求できるものとします。

（７）前項に基づく請求額は、商品ページに記載された商品購入金額から、当該レンタルアイテムについて会員が既に支払ったレンタル料、自動延長レンタル料および返却手数料を控除した金額とします。ただし、回収費用、再配送費用、本人確認不一致により発生した送料、修繕費用、特殊クリーニング費用、弁護士費用その他Enclopediaに生じた損害または実費については、商品購入金額から控除されず、別途請求できるものとします。

（８）レンタルアイテムの返却が遅延したことにより、汗、皮脂、飲食物、化粧品、香水、におい、雨濡れ、湿気その他の汚れまたは損傷が酸化、定着、変質、変色、劣化し、通常のクリーニングまたは特殊処理によっても除去または回復できなくなった場合、当該損害は会員の責任によるものとします。この場合、Enclopediaは、レンタルアイテムの素材、状態、希少性、アーカイブ品としての性質、再レンタルまたは販売の可否、修復可能性等を確認したうえで、会員に対し、修繕費用、特殊クリーニング費用、商品ページに記載された商品購入金額相当額、またはこれらに準ずる損害額を請求できるものとします。

（９）前各項にかかわらず、Enclopediaは、返却期限を過ぎた場合であっても、会員の連絡状況、返却状況、配送状況、過去の利用状況その他の事情を考慮し、請求、利用停止、返却期限の再設定その他必要な措置を個別に判断できるものとします。

（１０）返却完了とは、会員が本サービス上で返却手続きを行い、かつEnclopediaが指定する方法により運送会社への引渡しが確認された時点をいいます。単に会員が返却の意思を表示したこと、Enclopediaに連絡したこと、または配送伝票を所持していることのみをもって返却完了とはみなしません。`,
    },
    {
        title: "第９条（本人確認、配送および受取）",
        body: `（１）Enclopediaは、初回レンタル利用時、高額商品利用時、過去の利用状況その他Enclopediaが必要と判断した場合、運送会社による本人限定受取、本人確認書類の提示を伴う配送方法、電話番号確認、住所確認、決済手段の確認その他の本人確認手続きを求めることができるものとします。

（２）会員は、前項の本人確認手続きにおいて、Enclopediaに登録した氏名、住所、電話番号、生年月日その他の登録情報と一致する本人確認書類を提示し、自己の責任においてレンタルアイテムを受け取るものとします。

（３）登録情報と本人確認書類、配送先情報、受取人情報その他の情報が一致しない場合、虚偽の情報が登録されていた場合、本人以外による受取が試みられた場合、または本人確認が完了しない場合、Enclopediaは、レンタルアイテムの引渡しを拒否し、注文を取消し、会員資格の停止または取消し、今後の利用拒否その他必要な措置を取ることができるものとします。

（４）前項の場合において、配送、返送、再配送、本人確認、決済処理その他に要した費用が発生したときは、Enclopediaは、会員に対し、往復送料、再配送費用、事務手数料その他Enclopediaに発生した実費を請求できるものとします。

（５）会員は、レンタルアイテムを第三者に譲渡、転貸、質入れ、担保提供、売却、処分、改造、分解、すり替え、またはEnclopediaの承諾なく第三者に占有させてはならないものとします。`,
    },
    {
        title: "第１０条（レンタルアイテムの損傷、汚損、紛失等）",
        body: `（１）会員は、レンタルアイテムの貸出中に、盗難、紛失、滅失、破損、汚損、変色、変質、においの付着、部品欠損その他の異常が発生した場合、直ちにEnclopediaが定める方法によりその旨を連絡するものとします。

（２）レンタルアイテムの破損、汚損、変色、変質、においの付着、部品欠損その他状態に関する判断は、Enclopediaの基準に従うものとします。

（３）会員がレンタルアイテムの貸出中に発生した盗難、事故、火災、災害、管理不備その他いかなる事由によりレンタルアイテムを紛失、損傷、汚損または返却不能にした場合、会員は、本規約に基づき、商品購入金額相当額、修繕費用、特殊クリーニング費用その他Enclopediaに生じた損害を賠償するものとします。

（４）会員が登録した配送先住所、氏名、電話番号その他登録情報の誤りまたは不備により、レンタルアイテムが配送不能、返送、紛失、誤配送その他の状態となった場合、会員は、Enclopediaに生じた損害および実費を賠償するものとします。

（５）付属品のあるレンタルアイテムについては、会員は、付属品も含めて返却するものとします。付属品が返却されない場合、Enclopediaは、会員に対し、付属品の再取得費用、査定減額相当額、商品購入金額相当額その他Enclopediaに生じた損害を請求できるものとします。

（６）会員は、レンタルアイテムの代わりに別の商品、模造品、偽物、類似品その他Enclopediaが発送した商品と異なる物を返却してはならないものとします。

（７）返却時にレンタルアイテム以外の物が送付された場合、Enclopediaは、当該送付物について保管義務、返送義務、補償義務その他一切の責任を負わないものとします。

（８）前項の誤送付物について、Enclopediaが相当期間保管した後も会員から返送の申出がない場合、または会員と連絡が取れない場合、Enclopediaは、当該送付物がEnclopediaに到着した日から１か月経過後、会員が所有権その他一切の権利を放棄したものとみなし、任意に処分できるものとします。

（９）会員から誤送付物の返送申出があり、Enclopediaがこれに応じる場合、当該返送は着払いその他Enclopediaが指定する方法により行うものとします。`,
    },
    {
        title: "第１１条（本サービスのプランおよび料金）",
        body: `（１）本サービスで利用できるプラン、レンタル料、返却手数料、購入金額その他の料金は、本サービス上、商品ページ、注文画面その他Enclopediaが定める方法により表示します。

（２）会員は、Enclopediaが定める方法により利用プランの変更を申し込むことができます。変更後のプランの適用時期は、本サービス上に表示される条件またはEnclopediaが別途定める条件に従うものとします。

（３）会員は、本サービスの利用に関して発生するレンタル料、返却手数料、自動延長レンタル料、商品購入金額相当額、修繕費用、特殊クリーニング費用、送料その他本規約に基づく一切の金銭債務を、Enclopediaが指定する方法により支払うものとします。

（４）Enclopediaは、会員が本サービスに登録したクレジットカードその他の決済手段に対し、前項に定める料金および費用を請求できるものとし、会員はこれにあらかじめ同意するものとします。`,
    },
    {
        title: "第１２条（会員の認証方法）",
        body: `（１）本サービスは、会員のメールアドレス、パスワードその他Enclopediaが指定する認証情報により会員を認証します。

（２）会員は、自己の認証情報を第三者に譲渡し、貸与し、使用させ、または第三者と共有してはならないものとします。

（３）認証情報を用いて行われた本サービスの利用は、当該認証情報を登録した会員本人による利用とみなします。

（４）会員は、自己の認証情報の管理および使用について一切の責任を負うものとします。`,
    },
    {
        title: "第１３条（未返却、紛失、損傷、汚損および違約時の請求）",
        body: `（１）会員がレンタルアイテムを盗難、紛失、滅失した場合、または返却不能となった場合、Enclopediaは、商品ページに記載された商品購入金額相当額を上限として、会員に請求できるものとします。

（２）会員がレンタルアイテムを破損、汚損、変色、変質、においの付着、部品欠損その他の理由により、再レンタルまたは販売が困難な状態にした場合、Enclopediaは、商品ページに記載された商品購入金額相当額、修繕費用、特殊クリーニング費用、査定減額相当額その他Enclopediaに発生した損害を請求できるものとします。

（３）会員がレンタルアイテムを別の商品、模造品、偽物、類似品その他Enclopediaが発送した商品と異なる物にすり替えて返却した場合、Enclopediaは、商品ページに記載された商品購入金額相当額、調査費用、回収費用その他Enclopediaに発生した損害を請求できるものとします。

（４）返却期限を過ぎた場合の自動延長レンタル料、再返却期限を過ぎた場合の商品購入金額相当額、既払い額の控除、修繕費用、特殊クリーニング費用、回収費用その他の請求については、第８条の定めに従うものとします。

（５）Enclopediaから会員に対する通知は、会員が登録したメールアドレス、電話番号宛のSMS、電話、本サービス上の通知その他Enclopediaが適切と判断する方法により行うものとします。Enclopediaがこれらの連絡手段により通知を発信した場合、会員による受信、開封、確認または返信の有無にかかわらず、通常到達すべき時に通知が到達したものとみなします。ただし、法令上別段の定めがある場合はこの限りではありません。

（６）会員が返却期限を過ぎてもレンタルアイテムを返却せず、またはEnclopediaからの連絡に応答しない場合、Enclopediaは、会員資格の停止、アカウントの利用制限、以後のレンタル利用拒否、登録済み決済手段への請求、内容証明郵便による通知、弁護士その他専門家への委託、警察その他公的機関への相談または届出その他必要な措置を取ることができるものとします。

（７）前項の措置により、郵送費、内容証明作成費用、調査費用、回収費用、弁護士費用、決済手数料その他の費用が発生した場合、Enclopediaは、法令上認められる範囲で、会員に対し当該費用を請求できるものとします。

（８）本条に基づく請求は、Enclopediaに実際に発生した損害、レンタルアイテムの価値、アーカイブ品としての希少性、再取得困難性、再レンタルまたは販売機会の喪失、修復可能性、会員の対応状況その他一切の事情を考慮して合理的に算定するものとします。`,
    },
    {
        title: "第１４条（決済不能時の取扱い）",
        body: `（１）会員が登録したクレジットカードその他の決済手段により決済ができない場合、会員は、Enclopediaが指定する期限までに、別の有効な決済手段を登録し、またはEnclopediaが指定する方法により支払いを完了しなければなりません。

（２）決済不能の状態が継続した場合、Enclopediaは、会員に対し、メール、SMS、電話、本サービス上の通知その他の方法により支払いを求めることができるものとします。

（３）会員が支払いに応じない場合、Enclopediaは、会員資格の停止または取消し、注文の取消し、以後の利用拒否、内容証明郵便による通知、弁護士その他専門家への委託、法的手続その他必要な措置を取ることができるものとします。

（４）前項の措置によりEnclopediaに費用または損害が発生した場合、会員は、法令上認められる範囲で、当該費用または損害を賠償するものとします。`,
    },
    {
        title: "第１５条（サービス内容の変更、中断、終了）",
        body: `（１）Enclopediaは、利用者に事前に通知することなく、本サービスの内容の全部または一部を変更、追加、停止、中断または終了することができるものとします。

（２）Enclopediaは、次の各号のいずれかに該当する場合、本サービスの全部または一部の提供を停止または中断することができます。

一 本サービスに関するシステムの点検、保守、修理、更新を行う場合

二 火災、停電、地震、天災地変、感染症、戦争、暴動、法令の改廃、行政処分その他不可抗力により本サービスの提供が困難となった場合

三 通信回線、サーバー、外部サービス、決済サービス、配送サービスその他本サービスに必要な設備またはサービスに障害が発生した場合

四 その他Enclopediaが本サービスの停止または中断を必要と判断した場合

（３）Enclopediaは、本条に基づく本サービスの変更、停止、中断または終了により利用者に生じた損害について、Enclopediaに故意または重過失がある場合を除き、一切の責任を負いません。`,
    },
    {
        title: "第１６条（免責）",
        body: `（１）Enclopediaは、本サービスの内容変更、中断、終了によって利用者に生じたいかなる損害についても、Enclopediaに故意または重過失がある場合を除き、一切責任を負いません。

（２）Enclopediaは、利用者の本サービスの利用環境について一切関与せず、また一切の責任を負いません。

（３）Enclopediaは、本サービスが利用者の特定の目的に適合すること、期待する機能、商品的価値、正確性、有用性を有すること、利用者による本サービスの利用が利用者に適用される法令または業界団体の内部規則等に適合すること、不具合が生じないことについて、何ら保証するものではありません。

（４）Enclopediaは、本サービスが全ての情報端末、OS、ブラウザその他の利用環境に対応していることを保証しません。

（５）利用者は、OS、ブラウザ、アプリストア、決済サービス、配送サービスその他外部サービスの仕様変更、停止、中断、終了により、本サービスの一部または全部の利用が制限される可能性があることをあらかじめ了承するものとします。

（６）Enclopediaは、利用者が本サービスを利用したことにより直接的または間接的に発生した損害について、Enclopediaに故意または重過失がある場合を除き、一切責任を負いません。

（７）Enclopediaは、利用者その他第三者に発生した機会損失、業務の中断、逸失利益、間接損害、特別損害、付随的損害その他いかなる損害についても、Enclopediaに故意または重過失がある場合を除き、一切責任を負いません。

（８）前各項の規定は、Enclopediaに故意または重過失がある場合、または利用者が消費者契約法上の消費者に該当し、法令上免責が認められない場合には適用しません。

（９）前項が適用される場合であっても、Enclopediaは、Enclopediaの過失により利用者に生じた損害のうち、特別な事情から生じた損害については、Enclopediaに故意または重過失がある場合を除き、責任を負わないものとします。

（１０）本サービスの利用に関しEnclopediaが損害賠償責任を負う場合、Enclopediaの責任は、当該損害が発生した月に利用者から受領した本サービスの利用額を上限とします。ただし、Enclopediaに故意または重過失がある場合はこの限りではありません。

（１１）利用者と他の利用者または第三者との間に紛争またはトラブルが生じた場合、利用者は自己の費用と責任においてこれを解決するものとし、Enclopediaは一切責任を負いません。

（１２）利用者の行為により第三者からEnclopediaに対して請求、異議、苦情、損害賠償請求その他の申立てがなされた場合、利用者は、自己の費用と責任においてこれを解決するものとします。

（１３）前項の場合において、Enclopediaが損害、費用、弁護士費用その他の負担を被ったときは、利用者はEnclopediaに対し、これを賠償するものとします。`,
    },
    {
        title: "第１７条（損害賠償）",
        body: `（１）利用者が本規約に違反し、または本サービスの利用に関連してEnclopediaに損害を与えた場合、利用者は、Enclopediaに対し、当該損害を賠償するものとします。

（２）前項の損害には、直接損害、回収費用、調査費用、郵送費、内容証明作成費用、弁護士費用、訴訟費用、逸失利益その他Enclopediaに発生した一切の損害および費用を含むものとします。ただし、法令上認められる範囲に限ります。`,
    },
    {
        title: "第１８条（広告およびキャンペーン）",
        body: `（１）利用者は、本サービス上にEnclopediaまたは第三者の広告が掲載される場合があることを理解し、これを承諾するものとします。

（２）Enclopediaは、本サービス上の広告の形態、範囲、内容、掲載期間その他の条件を、Enclopediaの裁量により随時変更できるものとします。

（３）Enclopediaは、キャンペーン、クーポン、割引その他の施策を実施する場合があります。これらの施策の内容、適用条件、期間、変更、中止、終了については、Enclopediaが別途定めるものとします。`,
    },
    {
        title: "第１９条（知的財産権）",
        body: `（１）本サービスおよび本コンテンツに関する知的財産権は、Enclopediaまたは正当な権利を有する第三者に帰属します。

（２）利用者は、Enclopediaの事前の書面による承諾なく、本コンテンツを複製、転載、改変、翻案、配布、販売、公衆送信、貸与、譲渡、使用許諾その他の方法により利用してはならないものとします。

（３）本サービスの利用は、Enclopediaまたは第三者の知的財産権の譲渡または使用許諾を意味するものではありません。`,
    },
    {
        title: "第２０条（権利義務の譲渡禁止）",
        body: `（１）利用者は、Enclopediaの事前の書面による承諾なく、本規約上の地位または本規約に基づく権利義務の全部または一部を第三者に譲渡し、移転し、担保提供し、または承継させてはならないものとします。

（２）Enclopediaが本サービスに係る事業を第三者に譲渡し、または承継させる場合、Enclopediaは、本規約上の地位、権利義務、登録情報その他本サービスに関する情報を当該第三者に譲渡または承継させることができるものとし、利用者はこれにあらかじめ同意するものとします。`,
    },
    {
        title: "第２１条（反社会的勢力の排除）",
        body: `（１）利用者は、自己が反社会的勢力等に該当しないこと、また反社会的勢力等と一切関係を有しないことを表明し、保証するものとします。

（２）利用者が前項に違反した場合、Enclopediaは、事前に通知することなく、会員資格の停止または取消し、注文の取消し、レンタルアイテムの発送停止、以後の利用拒否その他必要な措置を取ることができるものとします。

（３）前項の措置により利用者に損害が生じた場合であっても、Enclopediaは一切責任を負いません。`,
    },
    {
        title: "第２２条（分離可能性）",
        body: `本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約のその他の条項および当該条項のその他の部分は、継続して完全に効力を有するものとします。`,
    },
    {
        title: "第２３条（準拠法および管轄）",
        body: `（１）本規約の準拠法は日本法とします。

（２）本サービスに関して利用者とEnclopediaとの間で紛争が生じた場合、Enclopediaの所在地を管轄する簡易裁判所または地方裁判所を第一審の専属的合意管轄裁判所とします。`,
    },
    {
        title: "第２４条（協議）",
        body: `本規約に定めのない事項、または本規約の解釈について疑義が生じた場合、利用者およびEnclopediaは、誠意をもって協議し、解決を図るものとします。`,
    },
];

export default function TermOfService() {
    const classes = useStyles();

    const title = "利用規約｜Enclopedia【公式サイト】";
    const description = "ファッションレンタルサービスEnclopedia(アンクロペディア)の利用規約に関するページです";

    useEffect(() => {
        headRewrite(title, description);
    }, []);

    return (
        <Container maxWidth="md" style={{ padding: "initial" }}>
            <Card className={classes.root}>
                <CardContent>
                    <Typography variant="subtitle1" component="div" className={classes.subtitle}>
                        Enclopedia運営
                    </Typography>

                    <Typography variant="h1" component="h1" className={classes.regulation}>
                        利用規約
                    </Typography>

                    <Typography variant="subtitle1" component="p" className={classes.body}>
                        {`この利用規約（以下「本規約」といいます。）は、Enclopedia（アンクロペディア）運営（以下「Enclopedia」といいます。）が提供するファッションレンタルサービス（以下「本サービス」といいます。）の利用条件を定めるものです。利用者は、本規約に同意したうえで本サービスを利用するものとします。`}
                    </Typography>

                    {terms.map((term) => (
                        <React.Fragment key={term.title}>
                            <Typography variant="subtitle1" component="p" className={classes.title}>
                                {term.title}
                            </Typography>
                            <Typography variant="subtitle1" component="p" className={classes.body}>
                                {term.body}
                            </Typography>
                        </React.Fragment>
                    ))}

                    <Typography variant="subtitle1" component="p" className={classes.enforcement}>
                        2023年1月31日施行
                        <br />
                        2026年6月10日改定
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
}
